import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../hooks/redux';
import { createProject } from '../store/slices/projectsSlice';
import ProjectForm from '../components/Projects/ProjectForm';
import { api } from '../services/api';

const CreateProjectPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { accessToken } = useAppSelector((state) => state.auth);

  const handleSubmit = async (data: any) => {
    // Extract files from data before creating project
    const files = data.files || [];
    const projectData = { ...data };
    delete projectData.files; // Remove files from project data

    // Create project first
    const result = await dispatch(createProject(projectData));
    if (createProject.fulfilled.match(result)) {
      const projectId = result.payload._id || result.payload.id;
      
      // Create files via ProjectFile API if any were uploaded
      if (files.length > 0 && accessToken) {
        try {
          for (const file of files) {
            await api.projectFiles.createFile(
              projectId,
              {
                type: file.type,
                filename: file.filename,
                originalFilename: file.originalFilename,
                url: file.url,
                thumbnailUrl: file.thumbnailUrl,
                mimeType: file.mimeType,
                size: file.size,
                description: file.description,
                synopsis: file.synopsis,
              },
              accessToken
            );
          }
        } catch (error) {
          console.error('Error creating project files:', error);
          // Continue navigation even if file creation fails
        }
      }
      
      navigate(`/projects/${projectId}`);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Create New Project</h1>
      <ProjectForm onSubmit={handleSubmit} />
    </div>
  );
};

export default CreateProjectPage;

